/**
 * External dependencies
 */
import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { Box, Text } from "@towersystems/towersystems-design-system";
import { noop, map } from "lodash";
import Dropdown from "react-dropdown";

/**
 * Internal dependencies
 */
import Button from "components/button";
import ButtonGroup from "components/button-group";
import FormFieldset from "components/forms/form-fieldset";
import FormLabel from "components/forms/form-label";
import { saveDashboardLayout } from "state/dashboard-layouts/actions";
import {
  getEditedId,
  getEditedDashboard,
} from "state/ui/dashboard-form/selectors";
import dashboardLibrary from "lib/dashboard-library";
import { requestReports } from "state/reports/actions";

/**
 * Style dependencies
 */
import "./styles.scss";

const EditDashboardForm = ({
  data = {},
  dashboardId,
  afterSave = noop,
  onCancel = noop,
  ...props
}) => {
  const [name, setName] = useState(data.name || "");
  const [dashboardTemplate, setDashboardTemplate] = useState("");

  const [isSaving, setSaving] = useState(false);
  const nameInput = useRef(null);
  const isDisabled = isSaving || name.length <= 0;

  useEffect(() => {
    nameInput.current.focus();
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      let data = {
        name,
        template: dashboardTemplate ? dashboardTemplate : undefined,
      };

      await props.saveDashboardLayout(dashboardId, data);
      await props.requestReports(); // dashboard api does not return any new reports
      afterSave(dashboardId, { name, data });
    } catch (e) {
      console.log(e);
    }
    setSaving(false);
  };

  const isNew = !dashboardId;
  return (
    <form onSubmit={handleSave}>
      <Box padding="xlarge">
        {isNew && (
          <FormFieldset>
            <FormLabel htmlFor="name">
              <Text size="xsmall" weight="medium">
                Select existing deck template
              </Text>
            </FormLabel>
            <Dropdown
              value={dashboardTemplate}
              options={map(dashboardLibrary.all(), ({ id, name }) => ({
                value: id,
                label: name,
              }))}
              onChange={({ value }) => setDashboardTemplate(value)}
            />
          </FormFieldset>
        )}
        <FormFieldset>
          <FormLabel htmlFor="name">
            <Text size="xsmall" weight="medium">
              Deck name
            </Text>
          </FormLabel>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            name="name"
            autoComplete="off"
            ref={nameInput}
          />
        </FormFieldset>
      </Box>
      <Box paddingBottom="xlarge" paddingRight="xlarge" paddingLeft="xlarge">
        <ButtonGroup>
          <Button disabled={isDisabled} secondary borderless>
            {dashboardId ? "Save deck" : "Create deck"}
          </Button>
          <Button onClick={() => onCancel()} lined>
            Cancel
          </Button>
        </ButtonGroup>
      </Box>
    </form>
  );
};

export default connect(
  (state) => {
    let dashboardId = getEditedId(state);
    let data = getEditedDashboard(state) || {};

    return {
      dashboardId,
      data,
    };
  },
  { saveDashboardLayout, requestReports }
)(EditDashboardForm);
